module.exports = __webpack_public_path__ + "images/apple-touch-icon-57x57-1b951277906a3c08b7b14bc15eb2acd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/favicons/apple-touch-icon-57x57.png
// module id = ./src/images/favicons/apple-touch-icon-57x57.png
// module chunks = 1